type VideoPlayer = typeof import('./video-player')
type Callback = (data: VideoPlayer) => void
type Event = {
    event: 'load'
    callback?: Callback
}

export type FandomVideoPlayerGlobal = {
    cmd: Event[]
}

export function load(): Promise<VideoPlayer> {
    return new Promise((resolve) => {
        import('./video-player').then((videoPlayer) => {
            resolve(videoPlayer)
        })
    })
}

function handleEvent(event: Event) {
    if (event.event === 'load') {
        load().then((data) => {
            if (event.callback) {
                event.callback(data)
            }
        })
    }
}

window.fandomVideoPlayer = window.fandomVideoPlayer || { cmd: [] }

window.fandomVideoPlayer.cmd.forEach(handleEvent)
// remove handled events
window.fandomVideoPlayer.cmd = []

window.fandomVideoPlayer.cmd.push = (...events: Event[]) => {
    events.forEach(handleEvent)

    // Just to make typescript happy
    return 0
}
